import React, { useContext } from 'react';
import "./Our_role.css";
import Common_subHeading from '../../common_components/common_subHeading/Common_subHeading';
import Pink_box from '../../common_components/pink_box/Pink_box';
import { Context } from '../../../utils/context';

function Our_role() {

  const {language} = useContext(Context);

  // const role = [
  //   {
  //     heading: "Quality Education",
  //     subHeading: "Access trusted academic pathways with clear guidance."
  //   },
  //   {
  //     heading: "Cultural Immersion",
  //     subHeading: "Prepare for real-life adaptation, not just admission."
  //   },
  //   {
  //     heading: "Structured & Ethical Process",
  //     subHeading: "Transparent steps, timelines, and documentation support."
  //   },
  //   {
  //     heading: "Pathway to Global Careers",
  //     subHeading: "Build international readiness through the right academic fit."
  //   },
  // ];


  const role = [
  {
    heading: language == 1 ? "Quality Education" : "Éducation de qualité",
    subHeading: language == 1 
      ? "Access trusted academic pathways with clear guidance." 
      : "Accédez à des parcours académiques fiables avec un accompagnement clair."
  },
  {
    heading: language == 1 ? "Cultural Immersion" : "Immersion culturelle",
    subHeading: language == 1 
      ? "Prepare for real-life adaptation, not just admission." 
      : "Préparez-vous à une adaptation réelle, pas seulement à l'admission."
  },
  {
    heading: language == 1 ? "Structured & Ethical Process" : "Processus structuré et éthique",
    subHeading: language == 1 
      ? "Transparent steps, timelines, and documentation support." 
      : "Des étapes, des délais et un accompagnement documentaire transparents."
  },
  {
    heading: language == 1 ? "Pathway to Global Careers" : "Voie vers des carrières internationales",
    subHeading: language == 1 
      ? "Build international readiness through the right academic fit." 
      : "Développez votre préparation internationale grâce à un parcours académique adapté."
  },
];

  return (
    <section className='Our_role'>
      <div className='container'>

        <Common_subHeading subHeading={language == 1 ? "What AFI Ensures for Every Student" : "Ce que l'AFI garantit à chaque étudiant"}/>

        <div className='pink_box_holder'>
          <div className='row justify-content-center'>

            {role.map((item, index) => (
              <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3' key={index}>
                <Pink_box box_text={item.heading} desc_text={item.subHeading}  />
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}

export default Our_role;
